import { Pipe, PipeTransform } from '@angular/core';
import  * as _  from 'lodash-es';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {

  transform(data: any[], groupbyColum: string ): any[] {
    return Object.values(_.groupBy(data, groupbyColum));
  }

}
